import { LocalAudioTrack } from 'twilio-video';
import { useCallback, useEffect } from 'react';
import useIsTrackEnabled from '../useIsTrackEnabled/useIsTrackEnabled';
import useVideoContext from '../useVideoContext/useVideoContext';
import { IS_AUDIO_TRACK_ENABLED } from '../../constants';

export default function useLocalAudioToggle() {
  const { localTracks } = useVideoContext();
  const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;
  const isEnabled = useIsTrackEnabled(audioTrack);

  const toggleAudioEnabled = useCallback(() => {
    if (audioTrack) {
      audioTrack.isEnabled ? audioTrack.disable() : audioTrack.enable();
    }
  }, [audioTrack]);

  useEffect(() => {
    window.localStorage.setItem(IS_AUDIO_TRACK_ENABLED, JSON.stringify(isEnabled));
  }, [isEnabled]);

  return [isEnabled, toggleAudioEnabled] as const;
}
